export const GET_QCRESULT = "GET_QCRESULT"
export const GET_QCRESULT_SUCCESS = "GET_QCRESULT_SUCCESS"
export const GET_QCRESULT_FAIL = "GET_QCRESULT_FAIL"

/* SEARCH QUERY */
export const SET_QCRESULT_SEARCH_QUERY = "SET_QCRESULT_SEARCH_QUERY"

/* RESET SEARCH QUERY */
export const RESET_QCRESULT_SEARCH_QUERY = "RESET_QCRESULT_SEARCH_QUERY"